import { Injectable } from '@angular/core';
import { PlatformMockApiService } from '@platform/lib/mock-api';
import {devices} from 'app/mock-api/recycling/devices/data';
import { cloneDeep } from 'lodash-es';

@Injectable({providedIn: 'root'})
export class DeviceMockApi
{
    private _recyclingData: any = devices;

    constructor(private _platformMockApiService: PlatformMockApiService)
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // Register Mock API handlers
    // -----------------------------------------------------------------------------------------------------
    registerHandlers(): void
    {
        this._platformMockApiService.onGet('api/devices').reply(() => [200, cloneDeep(this._recyclingData)]);
    }
}
